import React,{ useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/Footer'
import { useParams, Link, useNavigate } from 'react-router-dom';
import Rating from '../../components/Rating';
import { connect, useDispatch } from 'react-redux';
import { getProductDetails, createProductReview } from  '../../redux/actions/ProductActions';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import { FormControl, MenuItem, Select } from '@mui/material';
import { PRODUCT_CREATE_REVIEW_RESET } from '../../redux/constants/ProductConstants';



const ProductScreen = ({ productDetails, getProductDetails, createProductReview,  productReviewCreate, auth }) => {
    
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { id } = useParams();
    
    const [qty, setQty] = useState(1);
    const [rating, setRating] = useState(0)
    const [comment, setComment] = useState('')

    const { 
        loading:loadingProductReview, 
        success:successProductReview, 
        error:errorProductReview 
    } = productReviewCreate;

    const { loading, product, error } = productDetails;

    const {
        loading:loadingAuthInfo, 
        authInfo
    } = auth;


    useEffect(() => {
        window.scrollTo(0,0)

        if (successProductReview) {
            setRating(0)
            setComment('')
            dispatch({
                type: PRODUCT_CREATE_REVIEW_RESET
            })
        }

        getProductDetails(id)

        
    },[dispatch, getProductDetails, id, successProductReview])


    const addToCartHandler = () => {
 
        navigate(`/cart/${id}?qty=${qty}`)
    }

    const submitHandler = (e) => {
        e.preventDefault()

        createProductReview(id, {
            rating,
            comment,
        })
    }



    return (
        <>
            <Header />
            <Navbar />
            <div className='container max-w-screen-xl mx-auto p-4 mt-20  mb-4'>
                <Link to='/' className='px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium tracking-wider'>GO BACK</Link>
                {
                    loading ? <Loader /> : error ? <Message error msg={error} /> : (
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mt-9 sen-font'>
                            <div>
                                <img src={product.image} alt={product.name} />
                            </div>
                            <div>
                                <div className='text-2xl mont-font tracking-wide font-light mb-3 uppercase'>{product.name}</div>
                                <Rating value={product.rating} text={`${product.numReviews} reviews`} />
                                <div className='product__desc font sen-font leading-7 mt-3 md:h-56 md:overflow-auto md:overscroll-auto'><span className='font-medium'>Description:</span> {product.description}</div>
                                <div className='mt-4'>Category: <span>{product.category}</span></div>
                            </div>
                            <div className='border-2 h-fit'>
                                <div className='flex p-3 justify-between items-center border-b-2' >
                                    <div className='font-medium'>Price:</div>
                                    <div>₹{product.price}</div>
                                </div>
                                <div className='flex p-3 justify-between items-center border-b-2'>
                                    <div className='font-medium'>Status:</div>
                                    <div>{product.countInStock > 0 ? 'In stock' : 'Out Of Stock'}</div>
                                </div>

                                {product.countInStock > 0 && (
                                    <div className='flex p-3 justify-between border-b-2 items-center'>
                                        <div className='font-medium'>Qty</div>
                                        <select value={qty} className='px-4 py-1' onChange={(e) => setQty(e.target.value)}>
                                        {
                                            [...Array(product.countInStock).keys()].map((x) => (
                                                <option key= {x + 1} value={x + 1} >{x + 1}</option>
                                            ))
                                        }
                                        </select>
                                    </div>
                                )}

                                <div className='p-3'>
                                    <button 
                                        className='uppercase text-sm sen-font tracking-wide bg-black w-full p-3 text-white disabled:bg-gray-300 disabled:text-black' 
                                        disabled={product.countInStock === 0}
                                        onClick={addToCartHandler}
                                    >
                                    Add to cart</button>
                                </div>
                            </div>
                            <div>
                                <h2 className='text-xl'>Reviews</h2>
                                { product.reviews && product.reviews.length === 0 && <Message error msg={'No Reviews'} />}
                               
                                <div>
                                    { product.reviews && product.reviews.map((review) => (
                                            <div key={review._id} className='mt-5 bg-gray-50 p-4 rounded shadow'>
                                                <strong>{review.name}</strong>
                                                <Rating value={review.rating} />
                                                <p>{review.comment}</p>
                                                <p className='text-gray-600 mt-1'>{review.createdAt.substring(0, 10)}</p>
                                            </div>
                                        ))
                                    }
                                </div>

                                { successProductReview && <Message success msg={'Review submitted successfully'} /> }
                                { loadingProductReview && <Loader /> }
                                { errorProductReview && <Message error msg={errorProductReview} /> }

                                { loadingAuthInfo && <Loader /> }

                                {
                                    authInfo ? (
                                        <form className='mt-5' onSubmit={submitHandler}>
                                            <div className="mb-6">
                                                <FormControl className='w-full'>
                                                    <label htmlFor='row-label' className="block mb-2 text-md font-medium text-gray-900 ">Rating</label>
                                                    <Select
                                                        id='row-label'
                                                        value={rating}
                                                        onChange={(e) => setRating(e.target.value)}
                                                        className='w-full h-10 md:w-full'
                                                    >
                                                        <MenuItem value='0'>select...</MenuItem>
                                                        <MenuItem value='1'>1 - Poor</MenuItem>
                                                        <MenuItem value='2'>2 - Fair</MenuItem>
                                                        <MenuItem value='3'>3 - Good</MenuItem>
                                                        <MenuItem value='4'>4 - Very Good</MenuItem>
                                                        <MenuItem value='5'>5 - Excellent</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className="mb-6">
                                                <label htmlFor="comment" className="block mb-2 text-md font-medium text-gray-900 ">Your comment</label>
                                                <textarea 
                                                    id="comment" 
                                                    rows="4" 
                                                    value={comment}
                                                    onChange={(e) => setComment(e.target.value)}
                                                    className="block resize-none p-2.5 w-full text-md text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500" 
                                                    placeholder="Your comment...">
                                                </textarea>
                                            </div>
                                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">submit</button>
                                        </form>
                                    ) : (
                                        <div className='mt-5'>
                                            Please <Link to='/login' className='text-blue-600 underline'>sign in</Link> to write a review{' '}
                                        </div>
                                    )
                                }

                                
                            </div>
                        </div>
                    )
                }
            </div>
            <Footer />
        </>
    )
}


const mapStateToProps = (state) => ({
    productDetails: state.productDetails,
    productReviewCreate: state.productReviewCreate,
    auth: state.auth
})

export default connect(mapStateToProps, { getProductDetails, createProductReview } )(ProductScreen);